<template>
    <div class="my-item">
        <div class="custom-wrap">
            <template v-if="list && list.length">
                <div style="min-height: 400px;margin-bottom:20px;">
                    <Row :gutter="30">
                        <Col
                                v-for="(item) in list"
                                :key="item.id"
                                style="margin-bottom:20px;float: left;width: 25%;"
                        >
                            <div class="temp_con">
                                <p>{{item.description}}</p>
                                <div class="con_text" v-if="item.content">{{item.content.content}}</div>
                                <div class="con_text" v-else></div>
                                <div class="temp_btn">
                                    <div @click="edit(item)">编辑</div>
                                    <div @click="editState(item)">{{item.enabled?'屏蔽':'启用'}}</div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </template>
            <div class="u-empty" v-else>暂无数据</div>
        </div>
        <iModal
                title="编辑"
                @on-cancel="cancal"
                @on-ok="ok"
                v-model="visible"
                ok-text="保存"
                class-name="audience-info-modal"
                width="520"
        >
            <div class="text_con">
                <div>
                    <span>*</span>
                    <Input v-model="checkItem.content" type="textarea" :autosize=" { minRows: 5, maxRows:7 }" :rows="5" placeholder="请输入..." />
                </div>
                <p>可替换字段：【公司名称】【展会名称】【用户名】【密码】【展商登陆地址】【姓名】</p>
            </div>
        </iModal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "host-common-messageModel",
        props: {

        },
        data() {
            return {
                visible:false,
                list: [],
                checkItem:{},
                pageSize: 20,
                pageIndex: 1,
                totalCount: 0,
            };
        },
        computed: {
            ...mapGetters({

            }),

        },
        created() {
            this.init();
        },
        components: {

        },

        methods: {
            ...mapActions({
                getNote:"getNote",
                getOnlyMouder:'getOnlyMouder',
                editSmsTemp:'editSmsTemp'
            }),

            async init(){
                let res = await this.getNote()
                for(let i=0;i<res.length;i++){
                    let res1=await this.getOnlyMouder(res[i].id)
                    console.log( res1,'77777777')
                    if (res1){
                        res[i].content=res1
                    }
                    else{
                        res[i].content=''
                    }
                }
                this.list=res
                console.log( this.list,'77777777')
            },
            edit(item){
                if (item.content){
                    this.checkItem=JSON.parse(JSON.stringify(item.content)) ;
                    this.checkItem.id= this.checkItem.moduleId
                    console.log(  this.checkItem.id,'sssss')
                }
                else{
                    this.checkItem=JSON.parse(JSON.stringify(item)) ;
                    this.checkItem.id= this.checkItem.id
                    console.log(  this.checkItem.id,'2222')
                }

                this.visible=true;

            },

            async ok(){
                console.log(this.checkItem.content,'this.checkItem.content')
                if(!this.checkItem.content){
                    this.$Message.error('内容不能为空');
                    return
                }
                let req={
                    ModuleId:this.checkItem.id,
                    Content:this.checkItem.content,
                    IsOpen:1
                }
                let res=await this.editSmsTemp(req);
                console.log(res,'222222')
                if(res.successed){
                    this.$Message.success('保存成功');
                    this.visible=false;
                    this.init();
                }else{
                    this.$Message.error(res.message);
                }
            },
            cancal(){
                this.visible=false
            }
        },
    }
</script>

<style scoped lang="scss">
    .temp_con{
        background: #fff;
        cursor: pointer;
    &:hover{
         box-shadow: 0px 0px 10px 0px rgba(53, 153, 231, 0.2);
     }
    p{
        font-size: 16px;
        padding: 10px 32px 10px 20px;
        color: #262626;
        line-height: 1.5;
        font-weight: 500;
        border-bottom: 1px solid #e8e8e8;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 20px;
    }
    .con_text{
        height: 150px;
        padding: 10px;
        border-bottom: 1px solid #e8e8e8;
    }
    /deep/ .ivu-input-wrapper{
    .ivu-input{
        border-radius: 0;
        border: none;
    }
    }
    .temp_btn{
        display: flex;
        height: 50px;
        color: #888;
        background: #fafbfb;
    div{
        -webkit-user-select:none ;
        -moz-user-select:none;
        width:50%;
        border-right: 1px solid #dcdee2;
        display: flex;
        align-items: center;
        justify-content: center;
    &:hover{
         color: #1890ff;
     }
    &:last-child{
         border-right: none;
         width:calc(50% - 0.5px);
     }
    }
    }
    }
    /deep/ .text_con{
    div{
        display: flex;
    span{
        margin-right: 10px;
        font-family: SimSun;
        font-size: 14px;
        color: #ed4014;
    }
    }
    p{
        font-size: 12px;
        margin-top: 5px;
        color: #ccc;
        line-height: 1.5;
        margin-left: 17px;
    }
    }
</style>
